import jaLocale from "element-ui/lib/locale/lang/ja";
const jp = {
  login: {
    buttoo: {
      add: "add",
    },
  },
  dialog: {
    buttton: {
      close: "閉じる",
    },
    ReportError: {
      next: "次へ",
      h1: "エラーレポートはユーザーがデータ問題を解決し、データの品質を向上させるために私たちとコミュニケーションを行うことができる。",
      li1: "データに関する問題や質問がある場合 ",
      li2: "このデータを改善するために会社情報を提供したい場合 ",
      li3: "プライベートと考える可能性がある企業情報を開示しないことを選択した場合 ",
      li4: "サービスを改善するための建設的な提案がある場合 ",
      h2: "提出されたすべてのコメントはデータ検証の対象である。ユーザーは独自のユーザープロフィールを完了しなければならない。 当社の代表者は,あなたの会社を代表する権利を認証し、確認するためにあなたに連絡することができる。",
    },
  },
  Home: {
    Applications: "アプリケーション",
    SearchCompanies: "企業検索",
    SearchTrade: "貿易検索",
    SearchRisks: "リスク検索",
    SearchCountries: "国検索",
    SearchNews: "ニュース検索",
    SearchLeads: "潜在顧客の検索",
    SearchSanctions: "制裁検索",
    RiskScan: "リスクスキャン",
    SearchRelationship: "関係検索",
    DataServices: "データサービス",
    selectCountry: "国/地域",
    inputCompany: "会社名を入力してください",
    keWord: "キーワード",
    firstWord: "先頭文字",
    search: "検索",
    homeSeachTitle: "グローバルビジネスに焦点を当てる",
    homeTitleDetail:
      "CSIは、データドリブン型の調査・IT企業として、信用、リスク、ビッグデータの分野に特化しています。世界中の投資家やビジネスプロフェッショナルにデジタルツールを提供し、高度な分析手法とアルゴリズムを活用して、迅速かつ視覚的なインサイトを提供し、より賢明な意思決定を支援します。",
    phoneTitleDetail:
      "携帯電話のCSIアプリを使って、迅速に会社情報を検索・閲覧・取得することができます。",
    searchCompanyNum: "200以上の国や地域で5億社以上の企業を検索する",
    IndustryAnalysis: "業界分析",
    BusinessAnalytics: "ビジネス分析",
    ImportExportData: "データのインポートとエクスポート",
    CompanyNews: "社内ニュース",
    Sanctions: "制裁",
    BusinessIntelligence: "ビジネスインテリジェンス",
    CompanyIdentityVerification: "企業の身元確認",
    KYCSolutions: "KYCソリューション",
    OwnershipPenetration: "所有権の浸透",
    CompanyFinancialAnalysis: "会社財務分析",
    CreditRatings: "信用格付け",
    CreditReports: "信用報告書",
    ESGRatings: "ESG格付け",
    VendorScreening: "ベンダー選定",
    MarketResearch: "市場調査",
    EnterKeyword: "キーワード",
  },
  Toolbar: {
    Filter: "フィルター",
    Select: "選択",
    Edit: "編集",
    Sortby: "ソート順",
    Collect: "お気に入り",
    Saved: "保存済み",
    Compare: "比較",
    Export: "エクスポート",
    Download: "ダウンロード",
    Update: "アップデート",
    Reporterror: "エラー報告",
    Share: "シェア",
    ascending: "昇順",
    descending: "降順",
    Customfolder: "カスタムフォルダ",
    //未对应
    RiskScanning: "Risk Scanning",
    CreditAssessment: "与信評価",
    DataAnalysis: "Data Analysis",
    NewPortfolio: "New Portfolio",
    Print: "Print",
  },
  AiZaba: {
    whatareyousearchingfor: "何を探していますか?",
    CreditAnalyst: "信用分析",
    Assesses:
      "会社の信用価値を評価し、財務リスクを特定し、データ分析と信用評価を通じて安全な取引を確保します。",
    LegalAdvisor: "法律顧問",
    Provides:
      "コンプライアンスガイダンスを提供し、契約を審査し、ビジネス運営が法律に準拠し、紛争を避けるためにリスクを評価します。",
    BizConsultant: "ビジネスコンサルタント",
    Optimizes:
      "サプライチェーンを最適化し、購入者を識別し、市場の傾向を分析し、効率を向上させるためのカスタマイズされた戦略を提供することによって販売を高めます。",
    EconomicAnalyst: "経済アナリスト",
    Analyzes:
      "業界と地域経済の動向を分析し、ビジネスが情報に基づく決定を下し、競争力を維持するための支援を行います。",
  },
  navigationBar: {
    Notifications: "通知", //通知
    MarkasRead: "既読", //标记已读
    Viewall: "全表示", //查看全部
    SilverSubscriber: "シルバー会員", //银级用户
    Silversubscriberdate: "シルバー会員の有効期限", //银级到期日
    GoldSubscriber: "ゴールド会員", //金级用户
    Goldsubscriptiondate: "ゴールド会員の有効期限", //金级到期日
    AvailableCredits: "有効ポイント", //可用积分
    AddCredits: "ポイント購入", //购买积分
    IndivdualAccount: "個人口座", //个人账号
    GroupAccount: "法人・社団体アカウント", //集团账号
    OrdinaryUsers: "一般ユーザー",
    UserAccount: "ユーザーアカウント",
    Roles: "役割", //角色
  },
  ListofResults: {
    Country: "国/地域",
    Industry: "業界",
    CompanyType: "会社種類",
    CompanySize: "会社規模",
    CompanyStatus: "会社状況",
    CompanyName: "会社名",
    CoType: "会社種類",
    RegStatus: "登記状況",
    StateProvince: "州/省",
    CityCounty: "市/郡",
    DistrictCity: "地区/市",
    IncDate: "株式会社成立日",
    LegalForm: "法的形態",
    CoID: "会社ID",
    TaxNo: "税務番号",
    ListingInfo: "上場情報",
    Phone: "電話",
    Website: "ウェブサイト",
    Email: "メール",
    LegalPerson: "法定代表者",
    PostCode: "郵便番号",
    ISIC: "ISIC",
    IndustryDescription: "業界説明",
    NACE: "NACE",
    NAICS: "NAICS",
    CreditRating: "信用格付け",
    SolvencyIndex: "ソルベンシー指数",
    ProbabilityofDefault: "違約率",
    NoofEmployees: "従業員数",
    Revenue: "収入",
    TotalAsset: "総資産",
    NetProfit: "純利益",
    ROA: "ROA",
    ROE: "ROE",
    ShowMore: "もっと表示する",
    SelectCountry: "国/地域選択",
    ClearAll: "全削除",
    SelectIndustry: "業界選択",
    ListedCompany: "上場状況",
    YearsinBusiness: "営業年数",
    Sharethisinformation: "情報を共有する",
    Pleaseaddress: "1つ以上のメールアドレスを入力してください",
    Example: "例",
    message: "メッセージ",
    pleaseleaveamessage: "メッセージを残してください",
    Include: "含む",
    thisaddress: "会社名、ID、住所",
    CSIwebsite: "CSIウェブサイト",
    Update: "更新",
    Iftheavailable:
      "利用可能なオンラインデータが不十分または古くなった場合は、「更新」ボタンをクリックして、当社のローカルネットワーク調査員またはクレジットレポート機関から新しい調査されたビジネスクレジットレポートの即時更新を要求することができる。この更新の費用は会社ごとに1クレジットである。更新レポートは通常24時間から72時間までかかる。",
    Abusinesscredit:
      "ビジネスクレジットレポートは、対象会社の識別データ、登録記録、株主構造、会社歴史、経営説明、関連会社、実際の運営、貿易参照、財務データと分析、訴訟記録と制裁などの公式公開情報、信用分析と評価に関する詳細な情報を提供する。",
    Searchcompanies: "他の企業のメールを検索する",
    Rowsperpage: "ページごとの行数",
    Foundover: "の検索結果が",
    results: "件以上見つかりました",
    Remove: "削除",
    Confirm: "確認",
    Rescan: "再スキャン",
  },
  ContentTabs: {
    Background: "背景",
    BusinessActivities: "ビジネス活動",
    Performance: "パフォーマンス",
    Publications: "公開記録",
    CreditOpinion: "信用評価",
    MarketAnalysis: "市場分析",
    Snapshot: "スナップショット",
    Profile: "登記情報",
    Ownership: "所有権",
    RelatedCompanies: "関連会社",
    Management: "経営陣",
    Operations: "運営情報",
    Locations: "拠点分布",
    Industry: "業界",
    ImportExport: "輸入＆輸出",
    SupplyChain: "サプライチェーン",
    FinancialHighlights: "財務概要",
    RatioAnalysis: "比率分析",
    IndustryNorm: "業界標準",
    News: "ニュース",
    Sanctions: "制裁",
    IndustryStatistics: "業界統計",
    RatingAnalysis: "評価分析",
    CompetitiveAnalysis: "競争分析",
    Lawsuits: "訴訟",
  },

  Snapshot: {
    CompanyDQIdesc1:
      "データ品質指数 (DQI) は、完全性、有効性、ソースの信頼性、一致性、タイムリンシュ、両言語サポートなど、データのさまざまな側面を評価するためにアルゴリズムを使用する。",
    CompanyDQIdesc2:
      "このインデックスは、データの質を1から100のスケールで評価するために設計され、より高いスコアは優れたデータの質を示してる。アルゴリズムは、事前に定義されたルールや基準に基づいてデータを分析することができ,客観的で標準化された測定を可能になる。",
    CompanyDQIdesc3:
      "当社のデータ品質指数（DQI）は信頼性の高い指標として機能し、ユーザーがデータの品質を定量的に評価することができる。これにより、データに基づく意思決定が可能になり、データの全体的な価値と有用性が高まる。",
    CountryDQIdesc1:
      "データ品質指数（DQI）は、各国間のデータの信頼性、正確性、アクセシビリティを評価し、デジタルインフラ、ガバナンス、透明性の違いを反映する。先進国は通常、強力なデータシステム、オープンな政策、先進テクノロジーにより、より高いランキングを得ている一方、開発途上国はインフラ、規制、データ共有の実践におけるギャップに苦しんでいる。",
    CountryDQIdesc2:
      "主要な要因には、政府の透明性、データ保護法、技術の採用が含まれている。高いDQIは、より良い政策決定とビジネス決定を可能にする一方、低いスコアは、資が必要な領域を強調する。",
    CompanyDQI: "会社DQI", //公司数据质量指数 DQI
    CountryDQI: "国DQI", //国家数据质量指数 DQI
    CompanyTitle: "会社別データ品質指数（DQI）",
    CountryTitle: "国別データ品質指数（DQI）",
    Address: "アドレス", //地址
    CountyCity: "市区町村", //县/市
    ProvinceState: "都道府県", //省/州
    CountryRegion: "国/地域", //国家/地区
    ZipCode: "郵便番号", //邮政编码
    Website: "ウェブサイト", //网站
    Email: "メール", //电邮
    Tel: "電話", //电话
    LastUpdate: "最後の更新", //最近更新
    DataSource: "データソース", //数据来源
    LegalStatus: "法律状況", //法定状况
    CoID: "ID", //公司ID
    CompanyType: "会社種類", //公司类型
    RegistrationDate: "設立年月日", //注册日期
    RegistrationStatus: "登録状況", //注册状态
    Listed: "上場有無", //上市信息
    CurrentOpperations: "ビジネス状況", //经营状况
    IndustryCode: "業界コード", //行业代码
    BusinessActivities: "主要業務", //主营业务
    NoofEmployees: "従業員数", //员工数量
    NoofShareholders: "株主数", //股东数量
    Management: "管理状況", //管理状况
    Performance: "業務状況", //业绩表现
    Revenue: "収入", //收入
    Assets: "資産", //资产
    ProfitLoss: "利益", //利润
    Growth: "会社成長", //公司增长
    Competitiveness: "競争力", //竞争力
    CreditOpinion: "信用評価", //信用状况
    CreditRating: "信用格付け", //信用评级
    CreditScore: "与信点数", //信用评分
    ESGRating: "ESGレベル", //ESG 评级
    Solvency: "ソルベンシー", //偿还能力
    Sanctions: "グローバル制裁", //全球制裁
    CoName: "会社名",
    RegName: "登録名称",
  },
  Profile: {
    CompareCompanies: "会社比較",
    AddaCompany: "会社追加",
    CompanyProfile: "会社概要", //基本资料
    CompanyName: "会社名", //公司名称
    NativeName: "現地名", //当地名称
    CompanyID: "会社ID", //公司 ID
    VATNumber: "VAT番号", //VAT号
    StockCode: "株式コード", //股票代码
    Listed: "上場", //上市日期
    RegistrationDate: "設立年月日", //注册日期
    LegalForm: "法的形態", //公司性质
    CompanyType: "会社種類", //公司类型
    LegalStatus: "法律状況", //注册状态
    Jurisdiction: "管轄権", //司法管辖区
    RegisteredAddress: "登録アドレス", //注册地址
    ProvinceState: "都道府県", //省/州
    CountryRegion: "国/地域", //国家/地区
    ZipCode: "郵便番号", //邮政编码
    OperatingAddress: "経営アドレス", //经营地址
    LastUpdate: "最後の更新", //最近更新
    DataSource: "データソース", //数据来源
    History: "歴史", //历史记录
    RegisteredCapital: "資本金",
    PaidinCapital: "払込資本金",
    CountyCity: "市区町村",
  },
  Ownership: {
    UltimateBeneficiary: "最終受益者", //最终受益人
    InvolvingIndividuals: "関連自然人株主", //涉及自然人股东
    InvolvingEnterprises: "関連法人株主", //涉及法人股东
    ShareholderLevel: "株主レベル", //股东层级x
    Name: "名称", //名称
    Country: "国/地域", //国家/地区
    Location: "所在地", //地点
    Type: "種類", //类型
    Shares: "シェア", //股份
    Relation: "関係", //关系
    Individuals: "個人", //关系,
    PartiesInvolved: "関連者",
    RelatedCompany: "関連会社",
    CompanyShareholders: "会社株主",
    NGOShareholders: "NGO株主",
    NaturalPersonShareholder: "自然人株主",
    SubjectInvestments: "主体投資",
  },
  RelatedCompanies: {
    Total: "会社概要", //相关公司总计
    Entities: "会社名", //法人实体
    Countries: "国/地域", //国家/地区
    Branches: "支店", //分支机构
    RelatedComp: "関連会社", //关联公司
    Name: "名", //名称
    Country: "国/地域", //国家/地区
    Location: "所在地", //地点
    Type: "種類", //类型
    Relation: "関係", //关系
    BranchOffices: "支店",
    Individuals: "個人",
  },
  Management: {
    Management: "管理", //管理层
    ContactInfo: "連絡者", //联系人信息
    Countries: "国", //国家/地区
    Name: "名", //名称
    Position: "職位", //职位
    Department: "部门", //部门
    Country: "国/地域", //国家/地区
    ShareholderNot: "株主かどうか", //是否股东
    Relation: "関係", //关系
    Verification: "検証", //已验证
    Searchmoreemails: "もっとメールを検索する", //搜索更多电邮
    Roles: "役割", //角色
    EducationLevel: "教育レベル", //教育程度
    Phone: "電話番号", //电话
    Email: "メール", //电邮
    Verified: "確認", //已验证
    Searchmore: "他の会社のメールを検索する", //搜索更多其他公司的电邮
    Pleaseentername: "名前を入力してください",
    PleaseenterWebsite: "ウェブサイトを入力してください",
    UserSelfVerification: "ユーザー自己認証",
    Userverified: "ユーザー検証済",
  },
  Operations: {
    Operations: "運営",
    LineofBusiness: "事業分野", //业务范围
    BusinessTerritories: "ビジネス領域", //业务区域
    ImportExport: "輸入＆輸出", //进出口信息
    Viewtradeinfo: "もっと貿易情報を見る", //查看更多贸易信息
    ProductsServices: "製品/サービス", //产品/服务
    Products: "製品", //产品
    ProductImage: "製品イメージ", //产品图片
    ProductName: "製品名", //产品名称
    ProductDescription: "製品説明", //产品描述
    Details: "詳細", //详情
    Addproductinformation: "製品情報を追加する", //添加产品信息
    Showcaseyourcompany:
      "会社の製品やサービスを公開したい場合は、ここに製品やサービス情報を追加することができます。これはビジネスの発展を促進する良い方法です。提出内容が検討された後、データが公開されます。",
  },
  Locations: {
    Locations: "地位",
    CoName: "会社名", //业务范围
    Relationship: "関係", //关系
    Type: "種類", //类型
    Country: "国/地域", //国家/地区
    Location: "所在地", //地点
    Address: "アドレス", //地址
    Edit: "編集", //编辑
    CompanyLocatiionsMap: "地図上の会社の位置", //地图中的公司位置
    Selectaddresstype: "アドレスタイプを選択してください", //选择地址类型
    Subjectcompany: "対象会社", //目标公司
    Subsidiary: "子会社", //子公司
    RegisteredAddress: "登録アドレス", //注册地址
    OperationAddress: "営業所アドレス", //运营地址
    All: "全部", //全部
    Showlocation: "位置表示",
  },
  Industry: {
    IndustryTitle: "業界タイトル", //IndustryTitle
    IndustryDescription: "業界説明", //IndustryDescription
    ISIC: "ISIC", //ISIC
    ISICDescription: "ISIC説明", //ISICDescription
    NACE: "NACE", //NACEDescription
    NACEDescription: "NACE説明", //NACEDescription
    NAICS: "NAICS", //NAICS
    NAICSDescription: "NAICS説明", //NAICSDescription
    CSIC: "CSIC", //CSIC,
    CSICDescription: "CSIC説明", //CSICDescription
    AAAIC: "AAAIC", //AAAIC
    AAAICDescription: "AAAIC説明", //AAAICDescription
    GICS: "GICS", //GICS
    GICSDescriptio: "GICS説明", //GICS 描述
  },
  ImportExport: {
    TotalImportAmount: "総輸入額", //进口总额
    TopImportCountry: "最大輸入国", //最大进口国家/地区
    TopImportProduct: "最大輸入製品", //最大进口产品
    TotalExport: "総輸出額", //出口总额
    TopExportCountry: "最大輸出国", //最大出口国家/地区
    TopExportProduct: "最大輸出製品", //最大出口产品
    TradeVolume: "取引量", //贸易额
    ImportShipments: "輸入運送", //进口量
    ExportShipments: "輸出運送", //出口量
    ImportCountries: "輸入国", //进口国家/地区
    ExportCountries: "輸出国", //出口国家/地区
    ImportVolume: "輸入量", //进口量
    ExportVolume: "輸出量", //出口量
    TopSuppliers: "トップサプライヤー", //主要供应商
    ByNumberofShipments: "運送数量", //按出货量
    TopBuyers: "トップバイヤー", //主要买家
    ByNumberofShipments: "運送数量", //按出货量
    ImportQuantity: "輸入量", //进口数量
    IncreaseDecreasexRate: "増加/減少率", //增/减率
    ExportQuantity: "輸出量", //出口数量
    ImportsExportsRecords: "輸入＆輸出記録", //进出口记录
    Date: "日付", //日期
    Product: "製品", //产品
    HSCode: "HSコード", //HS 编码
    BuyerName: "バイヤー名", //买家名称
    Destination: "目的地", //目的地
    SupplierName: "サプライヤー名", //供应商名称
    Origin: "出発地", //原产地
    Amount: "金額", //金额
    Details: "詳細", //详情
    Imports: "輸入",
    Exports: "輸出",
    Shipments: "出荷数量",
    value: "価値",
    ByNumberofvalue: "価値順",
    viewmoretradeinfo: "詳細な貿易情報の表示",
    SearchHSCode: "HSコード検索",
  },
  SupplyChain: {
    Illustratesthesubjectcompany:
      "このグラフは、ターゲット企業の「購入」と「販売」の関係を示しています。体積が大きいほど、パイプは厚くなります。",
  },
  ShippingOrderDetails: {
    Date: "日付",
    MasterBillofLading: "マスター船荷証券",
    Source: "ソース",
    BillNo: "請求書番号",
    ImporterBuyer: "輸入者/購入者",
    ExporterSeller: "輸出者/販売者",
    Name: "名",
    Address: "アドレス",
    Country: "国/地域",
    Contact: "連絡先",
    Email: "メール",
    CargoInfo: "貨物情報",
    HSCode: "HSコード",
    Quantity: "数量",
    WeightUnit: "重量単位",
    ProductDescription: "製品説明",
    Amount: "金額",
    QuantityUnit: "数量単位",
    Weight: "重量",
    HSDescription: "HS説明",
    Incoterms: "インコタームズ",
    ShippingInfo: "出荷情報",
    Vessel: "船",
    Consignee: "荷受人",
    MeansofTransport: "運送手段",
    CountryofOrigin: "出発国",
    Voyage: "航行",
    Notifier: "通知者",
    CountryofDestnation: "目的国",
    AddressofOrigin: "出発地アドレス",
    Shipper: "出荷者",
    AddressofDestnation: "目的地アドレス",
    Container: "コンテナ",
    ContainerID: "コンテナID",
    ContainerType: "コンテナタイプ",
    ContainerDescDode: "コンテナDescコード",
    ContainerSize: "コンテナサイズ",
    ImportExport: "輸入者 / 輸出者",
  },
  FinancialHighlight: {
    Revenue: "収入",
    Profit: "利益",
    Growth: "成長",
    Liquidity: "キャッシュフローの状況",
    FinancialStructure: "財務構造",
    CreditOpinion: "与信意見",
    RiskIndicator: "リスク指標",
    Solvencyindex: "ソルベンシー指数",
    Year: "年",
    Change: "変更",
    NetProfit: "純利益",
    TotalAssets: "総資産",
    Equity: "純資産",
    GrossMargin: "粗利率",
    ProfitMargin: "粗利",
    ReturnonEquity: "純資産収益率",
    CurrentRatio: "流動比率",
    DebtRatio: "負債比率",
    FinancialHighlights: "関連会社からの財務データ",
    FinancialHighlightsTitle: "関連会社からの財務概要",
    CompanyName: "会社名",
    CompanyID: "会社ID",
    Country: "国/地域",
    CompanyStatus: "会社状況",
    Relations: "関係",
    Cancel: "取消",
    Select: "選択",
    RatioAnalysis: "メニュー",
    Financialperformancedata:
      "財務実績データは、様々な政府機関や地元信用情報機関から収集されており、さらに市場・業界調査を用いて計算・モデル化されています。実際の運営状況や業績分析に関するより詳細な情報については、当社サービスチームまでご連絡いただき、企業デューディリジェンスレポートの提出をお申し込みください。",
    Whenthesubjectsdata:
      "対象者のデータが不十分な場合、または顧客に関するより深い洞察を求める際、このプラットフォームは対象者に関連するすべてのエンティティを包括的に表示します。これには対象者の会社の株主、関連企業などが含まれます。 ",
    Byprovidingyou:
      "より広い視野を提供することで、このプラットフォームは情報に基づいた評価を行い、対象についてより深い理解を得られるように支援します。",
    PleaseSelectTheYeartoDisplay: "表示する年を選択してください",
    SelectUptoThreeYears: "最大3年間の選択",
  },
  RatioAnalysis: {
    ProfitabilityRatios: "収益率",
    Year: "年",
    Change: "変更",
    Returnonequity: "純資産収益率",
    Returnonassets: "資産収益率",
    Profitmargin: "粗利",
    Grossmargin: "粗利率",
    OperatingRatios: "運営比率",
    Assetsturnover: "資産回転率",
    Stockturnover: "在庫回転率",
    Salesperiod: "販売期間",
    Collectionperiod: "回収期間",
    Creditperiod: "信用期間",
    StructuralRatios: "構造比率",
    Currentratio: "流動比率",
    Quickratio: "当座比率",
    Shareholdersliquidityratio: "株主流動性比率",
    Solvencyratio: "ソルベンシー比率",
    Debtratio: "負債比率",
    ProductivityRatios: "生産率比率",
    Profitperemployee: "一人当たり利益",
    Operatingrevenueperemployee: "一人当たり営業収入",
    Shareholdersfundsperemployee: "一人当たり株主資本金",
    Totalassetsperemployee: "一人当たり総資産",
    GrowthRatios: "成長率",
    Salesgrowthrate: "売上成長率",
    Netprofitgrowthrate: "純利益成長率",
    Totalassetsgrowthrate: "総資産成長率",
    FinancialHighlights: "関連会社からの財務データ", //关联公司财务数据
    RatioAnalysis: "関連会社からの比率分析", //关联公司比率分析
    CompanyName: "会社名",
    CompanyID: "会社ID",
    Country: "国/地域",
    CompanyStatus: "会社状況",
    Relations: "関係",
  },
  IndustryNorms: {
    IndustryStatistics: "業界統計",
    ofcompaniesintheIndustry: "業界内会社数",
    oflistedCompaniesintheIndustry: "業界内上場会社数",
    oflargecompaniesintheIndustry: "業界内大手会社数",
    ofSMEsintheIndustry: "業界内中小会社数",
    ofcompaniesinsample: "サンプル会社数",
    ofcompaniesinloss: "赤字会社数",
    Observations: "観測",
    AverageValue: "平均値",
    MedianValue: "中央値",
    MaximumValue10: "最大値10％",
    MinimumValue10: "最小値10％",
    SubjectCompany: "対象会社",
    YearsinBusiness: "営業年数",
    TotalAssets: "総資産",
    TotalEquity: "総資本",
    Revenue: "収入",
    NetEarning: "純利益",
    Returnonassets: "資産収益率",
    Performance: "パフォーマンス",
    ProfitabilityRatios: "収益率",
    Returnonequity: "純資産収益率",
    Returnonassets: "資産収益率",
    Grossmargin: "粗利率",
    OperatingRatios: "運営比率",
    Stockturnover: "在庫回転率",
    Accountsreceivableturnover: "売掛金回転率",
    Assetsturnover: "資産回転率",
    Totalassetturnover: "総資産回転率",
    StructuralRatios: "構造比率",
    Currentratio: "流動比率",
    Quickratio: "当座比率",
    Shareholdersliquidityratio: "株主流動性比率",
    GrowthRatios: "成長率",
    Salesgrowthrate: "売上成長率",
    Netprofitgrowthrate: "純利益成長率",
    Totalassetsgrowthrate: "総資産成長率",
  },
  Lawsuits: {
    Lawsuits: "法律",
    Date: "日付",
    CaseCategory: "ケースカテゴリ",
    Title: "タイトル",
    CaseNo: "ケース番号",
    CauseofAction: "訴訟の原因",
  },
  News: {
    Date: "日付", //日期
    Title: "タイトル", //标题
    Source: "ソース", //来源
    Impact: "影響", //影响
    Searchcompanies: "他の会社のニュースを検索してください", //国家/地区
    SearchforTitle: "タイトル検索",
  },
  Sanctions: {
    Potentialcompliance: "潜在的なコンプライアンスリスクを検出した", //检测到潜在合规风险
    SeachbuttonNo: "この会社には有害的なことを検出しない", //未检测到任何与该公司相关的不良记录
    SeachbuttonYes: "もっと制裁記録を検索する場合、「制裁検索」ボタンを押す", //要搜索更多制裁记录，请点击“搜索制裁”按钮。
    SearchSanctions: "制裁検索",
    ViewDetails: "詳細表示",
    Sanctions: "制裁",
    Potentialcompliancerisks: "潜在的なコンプライアンスリスク",
    IDInfo: "ID情報",
    IDType: "ID類型",
    IDDescription: "ID説明",
    SanctionList: "制裁リスト",
    SanctionListInvolved: "関連制裁リスト",
    StartDate: "開始日",
    EndDate: "終了日",
    SourceList: "ソースリスト",
    SourceName: "ソース名",
    ProfileNotes: "概要説明",
    Link: "リンク",
    Name: "名",
    AssociationList: "協会リスト",
    AssociationID: "協会ID",
    AssociationType: "協会タイプ",
  },
  CreditOpinion: {
    CreditAssessment: "与信評価",
    CreditAssessmentfromtheRelatedCompanies: "関連会社からの与信評価",
    Year: "年",
    CreditRating: "信用格付け",
    LocalCreditScore: "ローカル与信点数",
    ProbabilityofDefault: "違約率",
    SolvencyIndex: "ソルベンシー指数",
    CreditLine: "与信金額",
    RiskIndicator: "リスク指数",
    RelatedCreditAssessment: "関連与信評価",
    CompanyName: "会社名",
    CompanyID: "会社ID",
    Country: "国/地域",
    CompanyStatus: "会社状況",
    Relations: "関係",
    Cancel: "取消",
    Select: "選択",
    LocalCreditScore: "ローカル与信点数",
    SolvencyIndex: "ソルベンシー指数",
    ProbabilityofDefault: "違約率",
    RiskIndicator: "リスク指数",
    CreditAssessmentMessage1:
      "対象のデータが不十分な場合、または顧客に対するより多くの洞察を得ることに興味がある場合、このプラットフォームは、対象に関連するすべてのエンティティの包括的なビューを提供する。これには、対象会社の株主、関連会社などが含まれている。 ",
    CreditAssessmentMessage2:
      "より広い視点を提供することにより、このプラットフォームは、より情報のある評価を行い、主題についてより深い理解を得ることができる。",
    LocalCreditRating: "地元クレジット評価",
    LocalCreditRatingDetail:
      "ビッグデータの力に基づいて、3ARatingは民間企業のための定量的な評価システムである。これは3ACreditとCreditreform Ratingの共同努力である。評価モデルは、非財政要因、財政要因、負の記録、業界特定の考慮事項を含む様々な重要な要因の包括的な評価に基づいて構築されている。評価モデルは印象的なギニ系数を示し、その堅固さと信頼性を示している。3ARatingは、最高の評価、3A1から最低の評価、3A19までの範囲にわたる。",
    CreditScore: "クレジットスコア",
    CreditScoreDetail:
      "クレジットスコアは,地方自治体から得たクレジット評価に基づいて、1から100のスケールで計算される。より高いスコアは、より良い信用価値を示す。",
    PossibilityofDefault: "違約可能性（PD）",
    PossibilityofDefaultDetail:
      "違約可能性（PD）は、短期的な流動性評価に焦点を当てたリスク評価の有用なツールである。",
    SolvencyIndexSI: "ソルベンシー指数（SI）",
    SolvencyIndexSIDetail:
      "ソルベンシー指数（SI）は、ビジネスパートナーのソルベンシーの迅速な評価を可能にする効果的で信頼性の高い早期警告指標である。高いSI値は、クライアントによるデフォルトのリスクが高いことを示す。SIは、優れた評価と考えられる100から、非常に負の特徴が存在する600までである。",
    ExternalRating: "外部評価",
    DefaultProbability: "違約確率(Pd1Year)",
    Rating: "3A評価 (>=,<=)",
    PleaseSelectTheYeartoDisplay: "表示する年を選択してください",
    SelectUptoThreeYears: "最大3年間の選択",
  },
  IndustryStatistics: {
    SubjectCompany: "対象会社",
    Country: "国/地域",
    Compare: "比較",
    Industry: "産業",
    CompanyType: "会社類型",
    CompanySize: "会社規模",
    CompanyStatus: "会社状況",
    YearsinBusiness: "営業年数",
    CompanyRating: "会社レベル",
    Liquidity: "キャッシュ・フロー・ステータス",
    NoofcoinIndustry: "会社業界番号",
    IndustryRating: "業界評価",
    Profitability: "収益性",
    SearchCountry: "国検索",
    Growth: "成長率",
    FinancialStructurt: "財務構造",
    Repaying: "返済能力",
  },
  RatingAnalysis: {
    IndustyAnalysis: "産業分析",
    GeographicAnalysis: "地理分析",
    CompanyTypeAnalysis: "会社類型分析",
    BiusinessScaleAnalysis: "ビジネス規模分析",
    HistoryAnalysis: "歴史分析",
    NormalDistribution: "正規分布",
    SubjectCompany: "対象会社",
    Probabilityofthesubjectratinginitsindustry: "業界内対象評価率",
    Maximum: "Max 10%",
    Mean: "中央値",
    Average: "平均値",
    Minimum: "Min 10%",
    RatingDistribution: "評価分布",
    Revenue: "収入",
    Earning: "利益",
    TotalAssets: "総資産",
    Subjectratinginitsindustrybyfinancialindicators: "業界内対象財務指標評価",
    Best: "最高",
    Worst: "最低",
    Rankingofsubject: "業界内対象評価ランキング",
    Industy: "産業",
    Percentilerank: "比率ランキング：％対象の会社を超える",
    Historicaldevelopmentofsubject: "業界内対象評価の発展歴史",
    IndustryAverage: "業界平均",
    SubjectRatingChanges: "対象評価変動",
    CreditScore: "信用評価",
    NOofCompanies: "会社数",
    ofCompanies: "%企業",
    CreditRating: "信用レベル",
    CompanySize: "会社規模",
    YearsinBusiness: "営業年数",
    SubjectsIndustryConcentrationAnalysis: "主体業界の集中度分析",
    GeographicdistributionofSubjectsratingintsindustry:
      "業界における被験者の評価地理的分布",
    GeographicdistributioninSubjectindustry:
      "被験者が所属する業界の地理的分布：",
    RatingDistributioninSubjectsLocation: "被験者所在地のスコア分布",
    Ratinganalysisofcompanies: "同業種の異なる経営年限会社の格付け分析",
    Subjectsratinghistory: "同じ歴史を持つ同業者と比較した被験者のスコア履歴",
    Ratingrankingofcompanieswithsamehistory:
      "同じ履歴を持つ企業の格付けランキング",
    Ratingstatistics: "同年の経営企業格付け統計",
    Subjectratingcomparing: "同業他社と比較したトピック評価",
    Subjectratinginitsgroup: "グループ内の被験者スコア：",
    Analysisbasedonnature: "主体業界の企業特性に基づく分析",
    Subjectratingpositioninitscompanytype: "企業タイプのトピック評価の場所:",
    Ratingstatisticsofcompanies: "同業企業の格付け統計",
    Ratinganalysisofcompanies: "同業他社の格付け分析",
    Probabilityofsubjectrating: "その規模の範囲内で、その業界の学科格付け確率",
    Subjectratingcomparingwithindustry: "同業他社とのトピック評価:",
    RatingRankingofthecompanies: "同業同規模企業の格付けランキング",
    Ratingstatisticsofcompanies: "同規模・同業界企業格付け統計",
    Rank: "ランキング",
    Rating: "評価",
  },
  CompetitiveAnalysis: {
    MarketPosition: "市場地位",
    Revenus: "収入",
    NetEarnings: "純利益",
    NetAssets: "純資産",
    TotalAssets: "総資産",
    Employees: "従業員",
    Mean: "中央値",
    Average: "平均値",
    Maximum: "Max (10%)",
    Worst: "Worst (10%)",
    Subjectcompany: "対象会社",
    PerformanceComparison: "表現比較",
    ProfitabilityRatios: "収益率",
    Grossmargin: "粗利率",
    Returnonassets: "資産収益率",
    Returnonequity: "純資産収益率",
    OperatingRatios: "運営比率",
    Stockturnover: "在庫回転率",
    Assetsturnover: "資産回転率",
    Collectionperiod: "回収期間",
    GrowthRatios: "成長率",
    Totalassetsgrowthrate: "総資産成長率",
    Salesgrowthrate: "売上成長率",
    Netprofitgrowthrate: "純利益成長率",
    StructuralRatios: "構造比率",
    Debtratio: "負債比率",
    Quickratio: "当座比率",
    Currentratio: "流動比率",
  },
  AccountCenterMenu: {
    SearchinSettings: "設定項目を検索",
    Account: "アカウント",
    MyAccount: "マイアカウント",
    ContactInfo: "連絡先情報",
    AccountSecurity: "アカウントセキュリティ",
    OrganizationalManagement: "組織管理",
    UserGroup: "ユーザグループ",
    User: "ユーザ",
    Role: "役割",
    MyDatabase: "マイデータベース",
    MyUsage: "使用状況",
    CompaniesViewed: "閲覧した企業",
    ReportsDownloaded: "ダウンロード済みのレポート",
    ReportUpdatesOrdered: "注文したレポートの更新",
    BillingandPayment: "請求と支払",
    BillRecords: "請求記録",
    PaymentRecords: "支払記録",
    CreditDeductions: "クレジット控除",
    InvoicesDownloaded: "ダウンロードしたインボイス",
    UserSettings: "ユーザ設定",
    Messages: "メッセージ",
    Notifications: "通知",
    HelpCenter: "ヘルプセンター",
    FAQ: "FAQ",
    Privacy: "プライバシー ポリシー",
    Terms: "利用規約",
    ReportIssues: "問題報告",
    UserGuide: "ユーザガイド",
    AboutCSI: "CSIについて",
  },
  MyAccount: {
    Logintime: "ログイン時間",
    SignOut: "サインアウト",
    DeleteAccount: "アカウント削除",
    AccountID: "アカウントID",
    Enteranewaddress: "新しいメールを入力してください",
    EnterVerificationCode: "承認コードを入力してください",
    SendverificationCode: "承認コードを送信してください",
    Password: "パスワード",
    Originalpassword: "旧いパスワード",
    Newpassword: "新しいパスワード",
    Confirmnewpassword: "新しいパスワードの確認",
    AccountOwnership: "アカウント所有権",
    IndividualAccount: "個人口座",
    GroupAccount: "グループアカウント",
    Organizationname: "組織名",
    CountryRegion: "国/地域",
    Address: "アドレス",
    City: "市",
    ZipCode: "郵便番号",
    FirstName: "名",
    LastName: "姓",
    PhoneNumber: "電話番号",
    Email: "メール",
    Change: "変更",
    Save: "保存",
    Cancel: "取消",
    LastLogin: "最後のログイン",
    RecentLogin: "直近のログイン",
    AverageLoginTime: "平均ログイン時間",
    TotalLoginAttempts: "全ログイン回数",
    Registrationtime: "登録時間",
    Role: "役割",
    Administrator: "管理者",
    Enterpriseusers: "企業ユーザー",
    EditImage: "画像編集",
    DeleteImage: "画像削除",
  },
  ContactInfo: {
    ContactInfo: "連絡先情報",
    FirstName: "名",
    LastName: "姓",
    PhoneNumber: "電話番号",
    Email: "メール",
    CountryRegion: "国/地域",
    AddressLine: "アドレスライン",
    City: "市",
    ZipCode: "郵便番号",
    Alternativecontactperson: "緊急連絡先",
    Setascontactperson: "連絡先設定",
    Edit: "編集",
  },
  AccountSecurity: {
    Setupmysecurityquestions: "セキュリティ質問を設定してください",
    Pleasechooseaquestion: "質問を選択してください",
    Pleaseentertheanswertothequestion: "質問の答えを入力してください。",
    SessionTimeoutAutomaticLogoutSettings:
      "ログインタイムアウト：自動ログアウト設定",
    Thesystemwillautomatically:
      "一定時間操作がない場合、自動的にログアウトします。デフォルトのタイムアウトは5分ですが、必要に応じて調整できます。",
  },
  MyDatabase: {
    TotalNumberofCompaniesSearched: "検索した会社の総数",
    TotalNumberofCompaniesCollected: "お気に入り会社の総数",
    TotalNumberofUpdateReportsOrdered: "注文した更新レポートの総数",
    Date: "日付",
    UserName: " ユーザー名",
    CompanyName: "会社名",
    Status: "ステータス",
    UsageType: "使用類型",
    Entercompanyname: "会社名を入力してください",
    Download: "ダウンロード",
  },
  OrganizationalManagement: {
    GroupName: "グループ名",
    ParentGroupName: "親グループ名",
    Organization: "組織",
    GroupID: "グループID",
    GroupStatus: "グループ状態",
    Operation: "操作",
    NewlyBuilt: "新規",
    UserAccount: "ユーザアカウント",
    Role: "役割",
    AccountStatus: "アカウント状態",
    RoleName: "役割名",
    Position: "職位",
    RoleStatus: "役割状態",
    Valid: "有効",
    Invalid: "無効",
    PermissionSettings: "権限設定",
    ShowMore: "もっと表示する",
    Search: "検索",
    Cancel: "取消",
    Confirm: "確認",
    NewGroup: "新グループ",
    EnterGroupName: "グループ名入力",
    NumberofGroups: "グループ数",
    Groups: "グループ",
    Roles: "役割",
    NewRoles: "新役割",
    EnterNewRole: "新役割入力",
    Users: "ユーザー",
    EnterUserName: "ユーザー名入力",
  },
  BillingandPayment: {
    TotalNumberofOrders: "注文合計数",
    TotalPaymentAmount: "支払総金額",
    TotalDeductionCredits: "控除ポイント総数",
    Date: "日付",
    UserAccount: "ユーザアカウント",
    CompanyName: "会社名",
    OrderNo: "注文番号",
    OrderType: "注文種類",
    OrderStatus: "注文状態",
    Download: "ダウンロード",
    PaymentAmount: "支払金額",
    Contactus: "お問い合わせ",
    DownloadInvoice: "インボイスをダウンロードする",
    CreditsDeducted: "控除済みポイント",
    ReportOrderStatus: "注文状況を報告する",
    CompanyID: "会社ID",
    CountryRegion: "国/地域",
    AddressLine: "アドレスライン",
    City: "市",
    ZipCode: "郵便番号",
    FirstName: "名",
    LastName: "姓",
    PhoneNumber: "電話番号",
    Email: "メール",
    BankAccountHolderName: "銀行口座保有者名",
    BeneficiaryBankName: "受益者銀行名",
    SWIFTCODE: "SWIFTコード",
    AccountNumber: "アカウント番号",
    BeneficiaryBankAddress: "受益者銀行アドレス",
    ABA: "ABA(ルーティング番号)",
    IBANnumber: "IBAN番号",
    StartingMonth: "開始月",
    EndMonth: "終了月",
  },
  UserSettings: {
    LanguageandLocation: "言語と位置",
    Language: "言語",
    Selectyourpreferedlanguage: "好きな言語を選択してください",
    Location: "位置",
    Selectyourlocation: "あなたの位置を選択してください",
    NotificationSetting: "通知設定",
    EmailNotification: "メール通知",
    ServiceUpdates: "サービス更新",
    CompanyNews: "会社ニュース",
  },
  AddCredit: {
    Customizeyourplan: "必要に応じて計画のカスタマイズ",
    Silver: "シルバー",
    Gold: "ゴールド",
    Enterpris: "企業",
    Credit: "クレジット",
    Remaining: "残り",
    Points: "ポイント",
    Usermonth: "ユーザー/月",
    Useryear: "ユーザー/年",
    PaidMonthlyRenews: "自動更新不要の月間支払",
    PaidAnnuallyRenews: "自動更新不要の年間支払",
    ForFullSupport: "ニーズに対する完全なサポート",
    Each: "毎",
    CreditsCharged:
      "アカウントがアクティブなままである限り、アカウント内のポイント数は期限切れにならない。",
    PaidMonthly: "月単位で購入",
    PaidAnnually: "年単位で購入",
    BuyNow: "今すぐ購入",
    ContactNow: "すぐに連絡",
    SearchCompanies: "企業を検索し、次のような企業データに即時アクセスする:",
    EverythinginSilverPackage:
      "シルバーロックコースの内容以外、追加内容は下記のようである:",
    CreditsCanbeUsed: "ポイントには次のようなデータサービスが追加される:",
    UnlimitedAdvancedSearch: "無制限の拡張検索",
    ViewCompanyProfile: "会社プロフィールの表示",
    CompanyOwnershipStructure: "会社所有権構造",
    CompanyFamilyTree: "会社関連状況",
    Companymanagement: "会社管理層",
    CompanyContactsinfo: "会社連絡先",
    BusinessActivities: "ビジネス活動",
    IndustryBasics: "業界概況",
    ImportExportRecords: "輸出入の歴史",
    CompanyPublications: "会社公開情報",
    CompanyNews: "会社ニュース",
    DownloadOnlineReport: "オンラインレポートのダウンロード",
    ManagementDetails: "管理層詳細",
    ShareholderPenetration: "株主構造図",
    Financialinfo: "財務情報",
    FinancialAnalysis: "財務分析",
    CreditAssessment: "信用評価",
    IndustryAnalysis: "業界分析",
    MarketAnalysis: "市場分析",
    SupplyChaininfo: "サプライチェーン情報",
    CheckSanctions: "制裁情報",
    CompanyComparison: "会社比較",
    DataExport: "データエクスポート",
    MonitoringService: "監視サービス",
    DiscountForFreshUpdateReports: "オフラインレポートサービスの更新",
    SearchCompany: "会社検索",
    SearchLeads: "リード検索",
    SearchTrade: "貿易検索",
    SearchPeople: "人員検索",
    SearchCountry: "国検索",
    SearchNews: "ニュース検索",
    SearchSanction: "制裁検索 ",
    DataServices: "データサービス",
    APIPlans: "APIカスタマイズ",
    VolumeDiscounts: "ボリューム割引",
    GroupAccountsWithMultipleUsers: "グループアカウントサービス",
    CustomizedPlans: "個性化サービス",
    FreshInvestigatedCreditReportsWorldwide: "最新のグローバル信用レポート",
    BusinessMonitoringServices: "業務監視サービス",
    BusinessProcessVerificationServices: "業務プロセス検証サービス",
    VendorComplianceReports: "ベンダーコンプライアンスレポート",
    MarketResearch: "データサービス",
    More: "その他…",
    Contactus: "お問い合わせ",
    PaymentMethod: "支払い方法",
    CreditCardNumber: "クレジットカード番号",
    EnterCardNumber: "カード番号入力",
    ExpirationDate: "有効期間",
    Fullnameoncard: "カードのフルネーム",
    EnterFullname: "フルネーム入力",
    EnterProvinceState: "省/州入力",
    CVCCode: "CVCコード",
    EnterCVCCode: "CVCコード入力",
    IncorrectCreditCardNumberformat:
      "クレジットカード番号のフォーマットが正しくありません",
    IncorrectExpMonthformat: "有効期限月の形式が正しくありません",
    IncorrectExpYearformat: "有効期限年の形式が正しくありません",
    IncorrectFullNameformat: "フルネームの形式が正しくありません",
    IncorrectCountryformat: "国のフォーマットが正しくありません",
    IncorrectProvinceStateformat: "省/州のフォーマットが正しくありません",
    IncorrectCVCCodeformat: "CVCコードのフォーマットが正しくありません",
    TotalPurchase: "購買総額",
    Agree1: "「送信」をクリックすると下記内容を同意します ",
    Agree2: "CSIサービスプロトコルとプライバシー。",
    Submit: "提出",
    Month: "月",

    Year: "年",
    Country: "国/地域",
    ProvinceState: "都道府県",
    Cancel: "取消",
  },
  ReportIssues: {
    Whattypeoferrorsyouarereporting:
      "どのような問題をご報告しているでしょうか？",
    Tellusmoreaboutyourproblems: "もっと詳しくご説明ください。",
    Wouldyouliketoprovideascreenshotorafileregardingyourproblem:
      "問題に関するスクリーンショット或はファイルをご提供できるでしょうか？",
    Fillinyourcontactinformation: "連絡先情報を入力してください",
    FirstName: "名",
    LastName: "姓",
    PhoneNumber: "電話番号",
    Email: "メール",
    Edit: "編集",
  },
  //Risk Scan
  RiskScan: {
    RiskScan: "リスクスキャン",
    RiskScanInfo: " は、包括的な企業リスク情報を提供する統合プラットフォームです。ビジネス上の意思決定を保護するために、主要なリスクカテゴリごとに詳細な分析を提供します。",
    LegalRisk: "法的リスク",
    LegalRiskInfo: "会社の正当性を検証する",
    OrganizationalRisk: "組織リスク",
    OrganizationalRiskInfo: "管理安定性、企業構造の複雑さ、所有権の透明性",
    OperationalRisk: "組織リスク",
    OperationalRiskInfo: "管理安定性、企業構造の複雑さ、所有権の透明性",
    FinancialRisk: "財務パフォーマンスリスク",
    FinancialPerformanceRiskInfo: "収益性トレンド、流動性問題、貸借対照表の健康状態",
    CreditRisk: "信用リスク",
    CreditRiskInfo: "信用、支払履歴、違約確率",
    ComplianceRisk: "コンプライアンスリスク",
    ComplianceRiskInfo: "制裁、反マネーロンダリング規制、業界固有の法律の遵守",
    SustainabilityRisk: "持続可能性リスク",
    SustainabilityRiskInfo: "ESG（環境、社会、ガバナンス）要因と評判影響",
    IndustryRisk: "業界リスク",
    IndustryRiskInfo: "企業の業界全体の安定性と将来性を評価する",
    LetBegin: "始めましょう",
    AddcompaniesfromSearchResult: "検索結果から会社を追加する",
    AddcompaniesfromMyDatabase: "マイデータベースからの会社を追加する",
    Addcompaniesbyuploadmyownlist: "自分のリストをアップロードして会社を追加する",
    Cancel: "取消",
    Confirm: "確認",
    UploadFiles: "ファイルのアップロード",
    PleaseuploadyourfileinCVSformat: "xlsx形式でファイルをアップロードしてください。",
    Downloadxlsxtemplate: "xlsxテンプレートのダウンロード",
    Xcompanieswereuploadedsucessfuly: "社がアップロードに成功した。",
    Xcompanieswereidentifiedsucessfuly: "社の識別に成功した。",
    Xcompanieswerenotmatched: "社はマッチングしていない。",
    Uploadingfilefailed: "ファイルのアップロードに失敗しました。テンプレートを使用して再試行してください。",
    ALL: "全部",
    SearchLeads: "リード検索",
    LastUpdate: "最終更新",
    CompanyID: "会社ID",
    CompanyType: "会社タイプ",
    RegistrationDate: "登録日",
    RegistrationStatus: "登録状態",
    Listed: "上場",
    LegalStatus: "法的地位",
    NoofShareholders: "株主数",
    ShareholdingLayers: "持株層",
    NoofCorporateShareholders: "会社株主数",
    NoofNatualPersonShareholders: "自然人株主数",
    RelatedCompanies: "関連会社",
    OrganizationalStatus: "組織状態",
    OperatingAddress: "営業住所",
    IndustryCode: "業界コード",
    BusinessActivities: "商業活動",
    NoofEmployees: "従業員数",
    Management: "管理",
    CurrentOperations: "現在経営",
    Revenue: "収入",
    Assests: "資産",
    ProfitLoss: "利益/損失",
    Liquidity: "資産流動性",
    Growth: "成長",
    Performance: "業績",
    CreditRating: "信用レベル",
    CreditScore: "信用点数",
    PausibilityofDefault: "違約可能性（PD）",
    SolvencyIndex: "返済能力指数",
    DebtCollection: "債権回収",
    CreditOpinion: "信用意見",
    CompanySanction: "会社制裁",
    ProductSanction: "製品制裁",
    ExportControl: "輸出規制",
    AntiCorruptionAntiBribery: "反腐敗と反賄賂",
    Litigations: "訴訟",
    NegativeNews: "マイナスニュース",
    ESGScore: "ESGスコア",
    YearsinBusiness: "経営年限",
    Competitiveness: "競争力",
    WorkingCapital: "運営資金",
    FinancialStructure: "財務構造",
    Industrystatus: "成長",
    IndustryOutlook: "業界展望",
    NoofCompanies: "会社数",
    IndustryRanking: "業界ランキング",
    IndustryConcentration: "業界GDP%",
    IndustryCompetitiveness: "業界競争",
    IndustryDevelopment: "業界発展",
    CompanyName: "会社名",
    Legal: "法律",
    Organizational: "組織",
    Operational: "営業",
    Financial: "金融",
    Credit: "信用",
    Compliance: "コンプライアンス",
    Sustainability: "持続可能性",
    Industry: "業界",
    Download: "ダウンロード",
    StartDate: "開始日",
    EndDate: "終了日",
    Entercompanyname: "会社名を入力してください",
    //未对应
    Uploadyourlistofcompanies: "企業リストをアップロードすると、リスクスキャンが各エンティティのデータを即時に更新します。7つのリスクカテゴリーにわたる包括的な評価により、リスクスキャンはあなたのリスク管理を受動的な対応から前向きな戦略的優位性へと変革します。  ",
    Choose: "選択",
    Upload: "アップロード",
    Uploading: "アップロード中",
    Uploadwithamaximumfilesizeof1M: "（一度に最大100件までアップロード可能、ファイルサイズ上限は1MB） ",
    Tryagain: "再試行",
    Theuploadedonlyxlsx: "アップロードできるファイル形式はxlsまたはxlsxのみです",
    RiskScanning: "リスクスキャン中",
    Youhaveselectedatotalof: "選択した企業は合計",
    Tostartriskscanning: "社です。「確認」をクリックするとリスクスキャンを開始します",
    Datascanningisinprogress: "データスキャン中…...",
    ClearAll: 'すべてクリア',
    SelectUpdateDate: "最終更新日を選択",
    UpdateStatus: "更新ステータス",
    Updated: "更新済み",
    Notupdated: "未更新",
    Updating: "更新中",
    SelectRiskValue: "リスク値を選択",
    ReSelectData: "データを再選択",
    HistoricalData: "履歴データ",
    DiagnosticReport: "診断レポート",
    Good: "診断レポート",
    General: "普通",
    Differ: "相違",
    NotEvaluated: "未評価",
    ScanTime: "スキャン時間",
    Rescan: "再スキャン",
  },
  //Data Management
  DataManagement: {
    DataManagement: "データ管理",
    AllCompanies: "すべての会社",
    CompaniesViewed: "閲覧される会社",
    CompaniesCollected: "収集した会社",
    CompaniesUploaded: "アップロードした会社",
    MyPortfolio: "マイポートフォリオ",
    Date: "日付",
    CompanyName: "会社名",
    Country: "国",
    CompanyType: "会社タイプ",
    CompanyStatus: "会社ステータス",
    DQI: "DQI",
    Download: "ダウンロード",
    Addcompanies: "会社の追加",
    Filter: "フィルター",
    Selectcountry: "国選択",
    Selectindustry: "業界選択",
    Selectcompanytype: "会社タイプ選択",
    Selectcompanysize: "企業規模選択",
    Selectcompanystatus: "会社ステータス選択",
    Selectlistedcompanies: "上場企業選択",
    Selectcompanyyearsinbusiness: "会社営業年数選択",
    Industry: "業界",
    CompanySize: "企業規模",
    Listed: "上場",
    CompanyAge: "会社運営年数",
    SelectYear: "年選択",
    SelectQuarter: "四半期選択",
    SelectMonth: "月選択",
    Reset: "リセット",
    Search: "検索",
    MyDatabase: "マイデータベース",
    CountriesLocated: "所在国",
    YearsinBusiness: "経営年数",
    CompanyDQI: "会社DQI",
    RiskScan: "リスクスキャン",
    CreditAssessment: "信用評価",
    Uptodate: "最新",
    Average: "普通",
    Insufficient: "不十分",
    Good: "良い",
    Caution: "警告",
    Unknown: "未知",
    CompanyTag: "会社ラベル",
    Remove: "削除",
    Uploaded: "アップロード済み",
    Identified: "認識済み",
    Notmatched: "一致しない‌",
    Uploadfiles: "ファイルのアップロード",
    Identifythecompanywithmanualcheck: "手動検査による会社の識別",
    Identifyacompanymanually: "会社を手動で識別する",
    Pleaseprovideanyrelevantinformation: "検索結果を強化する可能性のある情報を提供してください。データアナリストが、最適な企業にマッチさせます。",
    RegistrationID: "登録ID",
    StateProvince: "州/省",
    Address: "住所",
    Otherinformation: "その他情報",
    Submit: "提出",
    Cancel: "取消",
    Confirm: "確認",
    PortolioName: "ポトシオ名",
    User: "ユーザー",
    Task: "タスク",
    NoofCompanies: "会社数",
    Entercompanyname: "会社名入力",
    SaveYourPortfolio: "ポートフォリオの保存",
    PortfolioName: "ポートフォリオ名",
    Notes: "備考",

    //未对应
    Rescan: "再スキャン",
    Match: "照合",
    Delete: "削除",
    Edit: "編集",
    AllData: "全データ",
    CountriesLocated: "所在国",
    EnterRegistrationID: "登記IDを入力",
    EnterAddress: "住所を入力",
    EnterInformation: "情報を入力",
    EnterPortfolioName: "ポートフォリオ名を入力",
    EnterUserName: "ユーザーを入力",
    SelectTaskName: "タスクを選択",
    EnterNotes: "備考を入力",
    OnlineMatching: "オンライン照合",
    StartingMonth: "開始月",
    EndMonth: "終了月",
  },
  //Search Relationship
  Relationship: {
    SearchRelationship: "関係検索",
    SearchRelationshipInfo:
      " は当社の最上級データサービス。あらゆる企業の包括的なコーポレートエコシステムを可視化し、調査対象企業の 360° 全体像を提供します:",
    UltimateOwnershipControl: "最終所有・支配構造",
    UltimateOwnershipControlInfo:
      "複雑な所有層を追跡し、UBO（実質的支配者）と全株主を特定。",
    InvestmentParticipation: "投資・提携関係",
    InvestmentParticipationInfo:
      "出資先、パートナー、参加企業を網羅。戦略的方向性と隠れた提携を発見。",
    SupplyChainNetwork: "サプライチェーンネットワーク",
    SupplyChainNetworkInfo:
      "取引先・仕入先を含む商流を把握し、事業の全体構造を理解。",
    Ourplatformempowers:
      "サーチ・リレーションシップは、機会の発見、コンプライアンスの効率化、リスク低減を支援。透明性は、検索ひとつで。",
    LetsBegin: "始めましょう",
    Company: "企業名",
    Product: "製品",
    Entercompanyname: "企業名を入力してください",
    Enterproductkeywords: "製品キーワードを入力してください",
    UltimateOwnershipGlobalCoverage:
      "最終所有・支配・投資軌跡／サプライチェーン／コンプライアンス最適化／リスク軽減／グローバル対応",
    CompanyName: "企業名",
    Country: "国・地域",
    Industry: "業種",
    CompanyType: "会社形態",
    CompanySize: "企業規模",
    CompanyStatus: "企業ステータス",
    ListingInfo: "上場情報",
    YearsinBusiness: "設立年数",
    ImportExport: "輸入＆輸出",
    HSCode: "HSコード",
    HsCodeProduct: "HSコード / 製品",
    IncDate: "株式会社成立日",
    CompanySnapshot: "企業概要  ",
    Address: "住所",
    CountyCity: "郡/市 ",
    ProvinceState: "州/都道府県 e",
    CountryRegion: "国/地域",
    ZipCode: "郵便番号",
    RegName: "登記名",
    Website: "ウェブサイト",
    Email: "メール",
    Tel: "電話",
    LastUpdate: "最終更新日",
    DataSource: "データソース",
    CompanyProfile: "企業プロフィール ",
    CoNativeName: "会社名",
    CompanyID: "会社ID",
    VATNumber: "VAT番号",
    StockNumber: "株式番号",
    Listed: "上場状況 ",
    RegistrationDate: "登記日",
    LegalForm: "法人形態",
    LegalStatus: "法的地位",
    Jurisdiction: "管轄区域",
    RegisteredAddress: "登記住所",
    OperatingAddress: "営業住所",
    Ownership:"所有権",
    Investments:"投資",
    PossibleVendors:"想定仕入先",
    PossibleClients:"想定顧客",
    UItimateBeneficiaryOwner:"最終受益者",
    ControllingShareholder:"支配株主",
    Participations:"出資・参加先",
    InvolvingIndividuals:"関係個人",
    InvolvingEnterprises:"関係企業",
    ShareholdingLayers:"持株階層 ",
    RelatedCompany:"関連会社",
    CompanyShareholder:"会社株主",
    NGOShareholder:"NGO株主",
    NaturalPersonShareholder:"自然人株主",
    SubjectsInvestments:"対象企業の投資先 ",
    Name:"名称",
    Location:"所在地",
    Type:"種別",
    Shares:"持株比率（％）",
    Relations:"関係性",
    ShareholdingLayer:"持株階層",
    PartiesInvolved:"関係当事者",
    RelatedCompanies:"関連会社",
    CompanyShareholders:"会社株主",
    NGOShareholders:"NGO株主",
    NaturalPersonShareholders:"自然人株主",
    ShareholderLevel:"株主階層",
    Numberofshareholderenterprises:"株主企業数",
    Thelargestholdingcompany:"最大支配会社",
    CurrentLevel:"持株階層",
    SharesonSubjectCo:"対象企業持株比率",

    //未对应
    ClearAll: "全削除",
    UBORuler:"UBO Ruler",
  },

  ...jaLocale,
};

export default jp;
